export default __webpack_public_path__ + "static/media/5_image_1.aa846472.png";